export const parseDateForUser = (dataArray)=> {
    if (!dataArray) return false ;
    const locale = 'pt-br'
    const dataParsed = new Date(dataArray[0], (dataArray[1] - 1), dataArray[2]);
    return dataParsed.toLocaleDateString(locale)
  }